import { render } from "./ManufacturingChallenges.vue?vue&type=template&id=7e8a27fa&scoped=true"
import script from "./ManufacturingChallenges.vue?vue&type=script&lang=js"
export * from "./ManufacturingChallenges.vue?vue&type=script&lang=js"

import "./ManufacturingChallenges.vue?vue&type=style&index=0&id=7e8a27fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e8a27fa"]])

export default __exports__